import { NgModule } from 'ng-metadata/core';
import { PassportSelectComponent } from './passport-select.component';

@NgModule({
  declarations: [
    PassportSelectComponent,
  ],
})
export class PassportSelectModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/common/passport-select/passport-select.module.ts